import { render, staticRenderFns } from "./l-medicament.html?vue&type=template&id=badf2c50&scoped=true&external"
import script from "./l-medicament.js?vue&type=script&lang=js&external"
export * from "./l-medicament.js?vue&type=script&lang=js&external"
import style0 from "./l-medicament.scss?vue&type=style&index=0&id=badf2c50&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "badf2c50",
  null
  
)

export default component.exports